import { AppState } from 'Store'

const getAll = (state: AppState) => state.orders.externalForms.externalForms.entries
const getOne = (state: AppState) => state.orders.externalForms.externalForm
const getTotal = (state: AppState) => state.orders.externalForms.externalForms.total_entries
const getParams = (state: AppState) => state.orders.externalForms.requestParams
const getOrder = (state: AppState) => state.orders.externalForms.order
const getProducts = (state: AppState) => state.orders.externalForms.products
const getRegionIp = (state: AppState) => state.orders.externalForms.regionIp
const getInstructionFile = (state: AppState) => state.orders.externalForms.instruction
const getWithInstruction = (state: AppState) => state.orders.externalForms.with_instruction
const getBuildFields = (state: AppState) => state.orders.externalForms.buildFields
const getRegionName = (state: AppState) => state.orders.externalForms.regionName

export const getExternalFormsSelector = {
	getAll,
	getOne,
	getTotal,
	getParams,
	getOrder,
	getProducts,
	getRegionIp,
	getInstructionFile,
	getWithInstruction,
	getBuildFields,
	getRegionName,
}
